import React, { Component } from 'react';
import FieldLabel from 'src/Components/FieldLabel/FieldLabel';
import TextInput from 'src/Components/TextInput/TextInput';
import PrimaryButtonGE from 'src/Components/PrimaryButtonGE/PrimaryButtonGE';
import LoadingButton from 'src/Components/LoadingButton/LoadingButton';
import './styles.scss';
import { validateEmail, validateName } from 'src/Utils';
import UpdateUserModalContainer from '../UpdateUserModal/UpdateUserModalContainer';
import info_icon from '../../Assets/Images/info_icon.svg';
import warning_icon from '../../Assets/Images/warning_icon.svg';
import { AnalyticsService } from 'src/Analytics/AnalyticsService';
import DropdownField from 'src/Components/Dropdown/DropdownField';
import { withTranslation } from 'react-i18next';

class AddAdmin extends Component {
  state = {
    headerText: this.props.t('formErrorText'),
    descriptionText: this.props.t('formErrorSubtext'),
    showOtherFields: false,
    showModal: false,
    activationKey: '',
    facilityName: '',
    showInputError: false,
    isNameAvailable: false,
    fieldErrors: {},
    isEdit : false,
  };

  componentDidMount() {
    this.props.manageSidemenu(true);
    this.getActivationKey();
    this.props.resetValues();
    this.props.getLanguageDetails();
    this.props.fetchRegexRequest();
    this.updateAnalytics();
    // NOSONAR: event.origin is ‘undefined’ as none listen to 
    // messages dispatched from window.postmessage.
    window.addEventListener('paste', (e) => e.preventDefault());
  }

  getActivationKey = () => {
    if (
      this.props.location &&
      this.props.location.state &&
      this.props.location.state.activationKey &&
      this.props.location.state.facilityName
    ) {
      let { activationKey, facilityName } = this.props.location.state;
      this.setState({ activationKey, facilityName });
    } else {
      this.props.history.goBack();
    }
  };

  componentDidUpdate(prevProps) {
    let { userValidationRes, userDetails, toastMessage } = this.props.admin;
    const { t } = this.props;
    if (userValidationRes && prevProps.admin.userValidationRes !== userValidationRes) {
      switch(userValidationRes.status){
        case 'VALID_DE_USER_DIFFERENT_PARENT':
          this.setState({
            showInputError: true,
            displayError: true,
            errorBlockType: 'red',
            typeError: 'different',
            headerText: t('userDiffParentHeader'),
            isEdit: false,
            descriptionText: t('userDiffParentDesc'),
          });
          break;
        case 'DISABLED_USER':
          this.setState({
            showInputError: true,
            displayError: true,
            errorBlockType: 'blue',
            typeError: 'same',
            headerText: t('disabledUserHeader'),
            descriptionText: t('doYouWantMsg') + ' ',
            isEdit: true,
          });
          break;
        case 'EXISTING_USER':
          this.setState({
            showInputError: true,
            displayError: true,
            errorBlockType: 'blue',
            typeError: 'same',
            headerText: t('existingUserHeader'),
            descriptionText: t('doYouWantMsg') + ' ',
            isEdit: true,
          });
          break;
        case 'INVALID_EMAIL_ID':
          this.setState({
            showInputError: true,
            displayError: true,
            errorBlockType: 'red',
            typeError: 'different',
            headerText: t('formErrorText'),
            isEdit: false,
            descriptionText: t('invalidEmailIDDesc'),
          });
          break;
        case 'VALID_DE_USER':
        case 'VALID_USER_WITHOUT_DE':
          let name = userValidationRes.name.split('~');
          let isNameAvailable = name ? true : false;
          this.setState({
            isNameAvailable,
          });
          let newValue = {
            firstName: name[0],
            lastName: name[1],
          };
          this.props.updateFieldValue(newValue);
          this.setState({
            showInputError: false,
            displayError: false,
            showOtherFields: true,
          });
          break;
        default:
          this.setState({
            showInputError: false,
            displayError: false,
            showOtherFields: true,
          });
        }
    }
    if (userDetails && prevProps.admin.userDetails !== this.props.admin.userDetails) {
        this.setState({
          showModal: true,
          isDisabled:
            userValidationRes.status === 'DISABLED_USER' ? true : false,
        });
    } 
    if (toastMessage && prevProps.admin.toastMessage !== toastMessage) {
        this.handleCancel();
    }
  }

  updateAnalytics = () => {
    const category = window.location.href.replace(window.location.origin, '');
    let catName = category.replace('/', '');
    catName = catName.includes('/') ? catName.split('/') : catName;

    const digitalData = {
      page: {
        pageInfo: {
          domain: document.domain,
          location: document.location,
          pageName: this.props.location?.state?.facilityName,
          siteSection: 'Add Admin',
          pageURL: document.URL,
        },
        category: {
          primaryCategory: Array.isArray(catName) ? catName[0] : catName,
          subCategory:
            Array.isArray(catName) && catName.length > 1 ? catName[1] : '',
          Product:
            Array.isArray(catName) && catName.length > 2 ? catName[2] : '',
          pageType: document.domain,
        },
      },
      user: {
        profile: {
          profileInfo: {
            loginStatus: 'logged in',
            profileID: this.props.subscription?.subscriptionInfo?.sfdcUserId,
          },
        },
      },
    };

    AnalyticsService.updateDigitalData(digitalData);
    AnalyticsService.trackEvent('setAnalyticsVariables');
    AnalyticsService.trackEvent('pageLoaded');
  };

  handleClick = () => {
    let { fieldValue } = this.props.admin;
    let { activationKey } = this.state;
    this.props.getUserDetails(fieldValue['workEmailAddress'], activationKey);
  };

  saveInputDetails = (type, e, item) => {
    let val =
      type === 'language'
        ? item.key
        : item;
    if (val) {
      this.props.updateError({ [type]: '' });
    }
    this.props.updateFieldValue({ [type]: val });
  };


  clickIcon = (item, id, errorMessage) => {
    this.props.updateFieldValue({ [item]: '' });
    this.props.updateError({ [item]: errorMessage });
    if (document.getElementById(id)) {
      document.getElementById(id).focus();
    }
  };

  updateInputVal = (id, errorMessage) => {
    let { fieldValue } = this.props.admin;
    if ((id === 'firstName' || id === 'lastName') && fieldValue[id]) {
      this.props.updateFieldValue({
        [id]: fieldValue[id].trim().replace(/\s+/g, ' '),
      });
    }
    if ((id === 'language') && fieldValue[id]) {
      this.props.updateFieldValue({
        [id]: fieldValue[id],
      });
    }
    if (
      !fieldValue[id] ||
      ((id === 'firstName' || id === 'lastName' || id === 'language') &&
        fieldValue[id] &&
        !fieldValue[id].trim())
    ) {
      this.props.updateError({ [id]: errorMessage });
    } else {
      this.validateProfileDetails(fieldValue);
    }
  };

  validateProfileDetails =(fieldValue) => {
    const { t } = this.props;
    let { regex } = this.props.admin;
    if (
      fieldValue['workEmailAddress'] &&
      !validateEmail(fieldValue['workEmailAddress'], regex)
    ) {
      this.props.updateError({
        ['workEmailAddress']: t('invalidEmailerror'),
      });
    }
    if (
      fieldValue['confirmWorkEmailAddress'] &&
      !validateEmail(fieldValue['confirmWorkEmailAddress'], regex)
    ) {
      this.props.updateError({
        ['confirmWorkEmailAddress']: t('invalidEmailerror'),
      });
    }
    if (fieldValue['firstName'] && !validateName(fieldValue['firstName'])) {
      this.props.updateError({
        ['firstName']: t('validFirstNameError'),
      });
    }
    if (fieldValue['lastName'] && !validateName(fieldValue['lastName'])) {
      this.props.updateError({
        ['lastName']: t('validLastNameError'),
      });
    }
  };

  verifyEmailAddress = () => {
    let { formError, fieldValue } = this.props.admin;
    let { activationKey } = this.state;
    const { t } = this.props;
    let errors = formError;
    if (!fieldValue['workEmailAddress'])
      errors['workEmailAddress'] = t('emptyWorkEmailAddError');
    if (!fieldValue['confirmWorkEmailAddress'])
      errors['confirmWorkEmailAddress'] = t('confirmEmailPlaceHolder');
    this.props.updateError(errors);
    if (Object.keys(formError).length > 0) {
      this.setState({
        displayError: true,
        errorBlockType: 'red',
        isFieldsError: true,
        headerText: t('formErrorText'),
        descriptionText: t('formErrorSubtext'),
        fieldErrors: { ...formError },
        isEdit: false,
      });
    } else {
      if (
        fieldValue['workEmailAddress'] &&
        fieldValue['confirmWorkEmailAddress']
      ) {
        let isMatching =
          fieldValue['workEmailAddress'].toLowerCase() ===
          fieldValue['confirmWorkEmailAddress'].toLowerCase()
            ? true
            : false;
        if (!isMatching) {
          this.setState({
            displayError: true,
            errorBlockType: 'red',
            isFieldsError: false,
            descriptionText: t('emailDoNotMatch'),
          });
        } else {
          this.setState({
            displayError: false,
            fieldErrors: {},
          });
          fieldValue['workEmailAddress'] =
            fieldValue['workEmailAddress'].toLowerCase();
          this.props.verifyEmailAddress(
            activationKey,
            'ADMIN',
            fieldValue['workEmailAddress']
          );
        }
      }
    }
  };

  cancelSelection = () => {
    this.setState({
      showModal: false,
    });
  };

  displayErrorBlock = () => {
    let {
      fieldErrors,
      errorBlockType,
      isFieldsError,
      headerText,
      descriptionText,
      typeError,
      isEdit,
    } = this.state;
    const { t } = this.props;
    return (
      <div
        className="error-wrapper"
        style={{
          backgroundColor: errorBlockType === 'red' ? '#a80925' : '#046B91',
        }}
      >
        <img
          className="error-icon"
          src={errorBlockType === 'red' ? warning_icon : info_icon}
        />
        {errorBlockType === 'red'}
        <div className="error-content">
          <p className="error-header">{headerText}</p>
          <p className="error-sub-value">
            {descriptionText}
            {typeError === 'same' && isEdit  ? (
              <>
                <span
                  style={{ textDecoration: 'underline', cursor: 'pointer' }}
                  onClick={this.handleClick}
                >
                  {t('editAccText')}
                </span>
                ?
              </>
            ) : null}
          </p>
          {isFieldsError ? (
            <>
              {Object.keys(fieldErrors).map((i) => {
                return (
                  <div key={i} className="error-sub-value">• {`${t(i)}`}</div>
                );
              })}
            </>
          ) : null}
        </div>
      </div>
    );
  };

  addUser = () => {
    let { fieldValue, userValidationRes, formError, languages } = this.props.admin;
    let { activationKey } = this.state;
    const { t } = this.props;
    let errors = formError;
    window.digitalData.link = {
      linkName: 'Create Account',
      linkType: 'addAdmin',
    };
    const selectedLanguageKey = this.selectLanguageKey(fieldValue, languages);
    
    console.log("selectedLanguageKey** ", selectedLanguageKey);
    AnalyticsService.trackEvent('link_click');

    if (
      !fieldValue['firstName'] ||
      (fieldValue['firstName'] && fieldValue['firstName'].trim().length === 0)
    )
      errors['firstName'] = t('emptyFirstNameError');
    if (
      !fieldValue['lastName'] ||
      (fieldValue['lastName'] && fieldValue['lastName'].trim().length === 0)
    )
      errors['lastName'] = t('emptyLastNameError');
    this.props.updateError(errors);
    if (Object.keys(formError).length > 0) {
      this.setState({
        displayError: true,
        errorBlockType: 'red',
        isFieldsError: true,
        headerText: t('formErrorText'),
        descriptionText: t('formErrorSubtext'),
        fieldErrors: { ...formError },
        isEdit: false,
      });
      window.scrollTo(0, 0);
    } else {
      let req = {
        accBodyId: fieldValue.hasOwnProperty('accBodyId')
          ? fieldValue.accBodyId.trim()
          : '',
        activationKey: activationKey,
        emailId: fieldValue.workEmailAddress,
        firstName: fieldValue.firstName,
        lastName: fieldValue.lastName,
        language: selectedLanguageKey.key,
        persona: ['ADMIN'],
        sfdcProfileStatus: userValidationRes.status,
      };
      this.setState({
        displayError: false,
        formError: {}
      }, () => {
        this.props.addUser(req, false);
      })
    }
  };

  componentWillUnmount() {
    this.props.manageSidemenu(false);
  }

  handleCancel = () => {
    this.props.resetValues();
    this.props.history.goBack();
  };

  renderUpdateUserModal = (userDetails, isDisabled, activationKey) => {
    const { showModal } = this.state;
    if(showModal){
      return(
        <UpdateUserModalContainer
          cancelSelection={this.cancelSelection}
          userDetails={userDetails}
          isDisabled={isDisabled}
          activationKey={activationKey}
        />
      )
    }
    return null;
  }

  getLanguageList = (languages) => {
    if(languages) return languages;
    else return [];
  }

  selectLanguageKey = (fieldValue, languages) => {
    if(!_.isEmpty(fieldValue) && fieldValue.hasOwnProperty('language')) return this.getLanguage(fieldValue, languages);
    else return languages[0];
  }  
  
  disableNameField = (isLoading, isNameAvailable) => {
    return (isLoading || isNameAvailable);
  }  
  
  disableEmailField = (isLoading, isEmailVerifying) => {
    return (isLoading || isEmailVerifying);
  }  
  
  getWorkEmailError = (formError, showInputError) => {
    return (!!formError.confirmWorkEmailAddress || showInputError);
  }

  renderOtherFields = () => {
    let {
      fieldValue = {},
      formError = {},
      isLoading = false,
      isEmailVerifying,
      languages,
    } = this.props.admin;
    let {
      showOtherFields,
      isNameAvailable,
      showInputError,
    } = this.state;
    const { t } = this.props;

    let availableLanguage = this.getLanguageList(languages);
    let selectedLanguageKey = this.selectLanguageKey(fieldValue, languages);
    let isNameFieldDisabled = this.disableNameField(isLoading, isNameAvailable);
    let isEmailDropdownDisabled = this.disableEmailField(isLoading, isEmailVerifying);
    let workEmailHasError = this.getWorkEmailError(formError, showInputError);
    console.log("selectedLanguageKey* ", selectedLanguageKey);
    if(showOtherFields) {
      return (
      <div className="admin-field-wrapper">
        <div className="admin-field-container">
          <div className="input-field-wrapper">
            <FieldLabel
              labelText={t('firstName')}
              isDisabled={isLoading}
            />
            <TextInput
              id="firstName"
              className="textfield-style"
              onChange={this.saveInputDetails.bind(this, 'firstName')}
              inputValue={this.validateFieldValues('FIRSTNAME', fieldValue)}
              iconClick={this.clickIcon.bind(
                this,
                'firstName',
                'firstName',
                t('emptyFirstNameError')
              )}
              onBlur={this.updateInputVal.bind(
                this,
                'firstName',
                t('emptyFirstNameError')
              )}
              isError={!!formError.firstName}
              errorMessage={this.validateFieldErrors('FIRSTNAME', formError)}
              isDisabled={isNameFieldDisabled}
            />
          </div>
        </div>
        <div className="admin-field-container">
          <div className="input-field-wrapper">
            <FieldLabel
              labelText={t('lastName')}
              isDisabled={isLoading}
            />
            <TextInput
              id="lastName"
              className="textfield-style"
              onChange={this.saveInputDetails.bind(this, 'lastName')}
              inputValue={this.validateFieldValues('LASTNAME', fieldValue)}
              iconClick={this.clickIcon.bind(
                this,
                'lastName',
                'lastName',
                t('emptyLastNameError')
              )}
              onBlur={this.updateInputVal.bind(
                this,
                'lastName',
                t('emptyLastNameError')
              )}
              isError={!!formError.lastName}
              errorMessage={this.validateFieldErrors('LASTNAME', formError)}
              isDisabled={isNameFieldDisabled}
            />
          </div>
        </div>
      </div>
      )
    } else {
      return (
      <div className="admin-field-wrapper">
        <div className="input-field-wrapper">
          <FieldLabel
            labelText={t('confirmEmail')}
            isDisabled={isEmailVerifying}
          />
          <TextInput
            id="confirmWorkEmailAddress"
            className="textfield-style"
            onChange={this.saveInputDetails.bind(
              this,
              'confirmWorkEmailAddress'
            )}
            inputValue={this.validateFieldValues('EMAIL', fieldValue)}
            iconClick={this.clickIcon.bind(
              this,
              'confirmWorkEmailAddress',
              'confirmWorkEmailAddress',
              t('confirmEmailPlaceHolder')
            )}
            contextMenuHidden={true}
            onBlur={this.updateInputVal.bind(
              this,
              'confirmWorkEmailAddress',
              t('confirmEmailPlaceHolder')
            )}
            isError={workEmailHasError}
            errorMessage={this.validateFieldErrors('EMAIL', formError)}
            isDisabled={isEmailVerifying}
          />{' '}
        </div>
        <div className="input-field-wrapper">
        <FieldLabel
            labelText={t('language')}
            isDisabled={isEmailDropdownDisabled}
          />
          <DropdownField
          id="language"
          onChange={this.saveInputDetails.bind(this, 'language')}
          options={availableLanguage}
          inputValue={selectedLanguageKey?.key}
          isDisabled={isEmailDropdownDisabled || availableLanguage.length === 1 ? true : false}
          isError={false}
          shadow={true}
          />
        </div>
      </div>
      )
    }
  }

  getCancelBtn = (isEmailVerifying, isLoading) => {
    const { t } = this.props;
    if(isEmailVerifying || isLoading) return <p className="cancel-button-disabled">{t('cancel')}</p>
    else return <p className="cancel-button" onClick={this.handleCancel}>{t('cancel')}</p>
  }

  getDisplayErrorDiv = (displayError) => {
    if(displayError) return <div className="admin-error-wrapper">{this.displayErrorBlock()}</div>
    else return null;
  }

  getOtherDiv = (isEmailVerifying, showOtherFields) => {
    return (isEmailVerifying || showOtherFields);
  }

  getEmailAddress = (fieldValue) => {
    if(fieldValue) return fieldValue.workEmailAddress;
    else return '';
  }

  getEmailAddressError = (formError, showInputError, showOtherFields) => {
    return ((!!formError.workEmailAddress || showInputError) && !showOtherFields);
  }

  getEmailMessage = (formError) => {
    if(formError) return formError.workEmailAddress;
    else return '';
  }

  getWrapperButton = (showOtherFields, isEmailVerifying, isLoading) => {
    if(showOtherFields) return this.loadingAdminButton(isLoading)
    else return this.loadingEmailButton(isEmailVerifying)
  }

  render() {
    let {
      fieldValue = {},
      formError = {},
      isLoading = false,
      userDetails,
      isEmailVerifying,
    } = this.props.admin;
    let {
      displayError,
      showOtherFields,
      isDisabled,
      facilityName,
      activationKey,
      showInputError,
    } = this.state;

    const { t } = this.props;
    
    let renderCancelBtn = this.getCancelBtn(isEmailVerifying, isLoading);
    let displayErrorDiv = this.getDisplayErrorDiv(displayError);
    let isOtherDiv = this.getOtherDiv(isEmailVerifying, showOtherFields);
    let emailAddress = this.getEmailAddress(fieldValue);
    let emailAddressError = this.getEmailAddressError(formError, showInputError, showOtherFields);
    let emailAddressMessage = this.getEmailMessage(formError);
    let wrapperButton = this.getWrapperButton(showOtherFields, isEmailVerifying, isLoading);

    return (
      <div className="new-admin-container">
        {this.renderUpdateUserModal(userDetails, isDisabled, activationKey)}
        <div className="admin-header">
          <p className="facility-name">{facilityName}</p>
          {renderCancelBtn}
        </div>
        <div className="admin-body-container">
          <div className="admin-body-wrapper">
            <div className="admin-title">{t('newAdmin')}</div>
            {displayErrorDiv}
            <div className="admin-field-wrapper">
              <div className="input-field-wrapper">
                <FieldLabel
                  labelText={t('workEmailAddress')}
                  isDisabled={isOtherDiv}
                />
                <TextInput
                  id="workEmailAddress"
                  className="textfield-style"
                  onChange={this.saveInputDetails.bind(
                    this,
                    'workEmailAddress'
                  )}
                  inputValue={emailAddress}
                  iconClick={this.clickIcon.bind(
                    this,
                    'workEmailAddress',
                    'workEmailAddress',
                    t('emptyWorkEmailAddError')
                  )}
                  onBlur={this.updateInputVal.bind(
                    this,
                    'workEmailAddress',
                    t('emptyWorkEmailAddError')
                  )}
                  isError={emailAddressError}
                  errorMessage={emailAddressMessage}
                  isDisabled={isOtherDiv}
                />
              </div>
            </div>
            {this.renderOtherFields()}
            <div className="admin-field-wrapper">
                <div className="button-wrapper">
                  {wrapperButton}
                </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  getLanguage(fieldValue, languages){
    if(fieldValue.language !== 'null' &&
        fieldValue.language !== null && fieldValue.language!== 'undefined' && fieldValue.language!== ''){
            return(
            languages
              .filter((x) => x.key === fieldValue.language)
              .pop()
            );
          }
          else{
            return(
             languages[0]
            );
          }
  }
  
  validateFieldValues =(fieldVal, fieldValue) => {
    let objVal = '';
    switch(fieldVal){
      case 'EMAIL':
        objVal = fieldValue ? fieldValue.confirmWorkEmailAddress : '';
        break;
      case 'LASTNAME':
        objVal = fieldValue ? fieldValue.lastName : '';
        break;
      case 'FIRSTNAME':
        objVal = fieldValue ? fieldValue.firstName : '';
        break;
      default:
        break;
    }
    return objVal;
  }
  
  validateFieldErrors =(fieldVal, fieldError) => {
    let objErrorVal = '';
    switch(fieldVal){
      case 'EMAIL':
        objErrorVal = fieldError ? fieldError.confirmWorkEmailAddress : '';
        break;
      case 'LASTNAME':
        objErrorVal = fieldError ? fieldError.lastName : '';
        break;
      case 'FIRSTNAME':
        objErrorVal = fieldError ? fieldError.firstName : '';
        break;
      default:
        break;
    }
    return objErrorVal;
  }
  
  loadingAdminButton  =(isLoading) => {
    const { t } = this.props;
    if(isLoading){
      return (<LoadingButton text={t('creating') + '...'} />);
    }
    else{
      return(<PrimaryButtonGE
        className="create-btn"
        text={t('createadmin')}
        onClick={this.addUser}
      />);
    }
  }
  
  loadingEmailButton =(isEmailVerifying) => {
    const { t } = this.props;
    if(isEmailVerifying){
      return (<LoadingButton text={t('checking') + '...'} />);
    }
    else{
      return(<PrimaryButtonGE
        className="continue-btn"
        text={t('continue')}
        onClick={this.verifyEmailAddress}
      />);
    }
  }
}

export default withTranslation()(AddAdmin);
